import { i1995 } from "../../../shared/assets/img";
import { i1998 } from "../../../shared/assets/img";
import { i2008 } from "../../../shared/assets/img";
import { i2019 } from "../../../shared/assets/img";
import { i2021 } from "../../../shared/assets/img";
import { i2022 } from "../../../shared/assets/img";
import { i2023 } from "../../../shared/assets/img";
import { i2024 } from "../../../shared/assets/img";
import { i2025 } from "../../../shared/assets/img";

export const historyCompany = [
    {
        id: "0",
        year: "1995",
        image: i1995,
        items: [
            {
                type: "paragraph",
                text: "Основание БКС в Новосибирске",
            },
            {
                type: "paragraph",
                text: "Все начиналось с маленького\nпомещения в 20 квадратных метров\nи двух очень амбициозных сотрудников.",
            },
        ],
    },
    {
        id: "1",
        year: "1998-2006",
        image: i1998,
        items: [
            {
                type: "heading",
                text: "1998",
            },
            {
                type: "paragraph",
                text: "БКС становится членом секции фондового рынка\nММВБ и участником РТС.",
            },
            {
                type: "heading",
                text: "2000",
            },
            {
                type: "listItem",
                text: "Открыт первый офис БКС в Москве.",
            },
            {
                type: "listItem",
                text: "Одними из первых в России предложили\nклиентам интернет-трейдинг.",
            },
            {
                type: "heading",
                text: "2002",
            },
            {
                type: "paragraph",
                text: "Вводится в эксплуатацию технология «Единый\nброкерский счет» (ЕБС).",
            },
            {
                type: "heading",
                text: "2005",
            },
            {
                type: "paragraph",
                text: "Запущена услуга персонального финансового\nконсультирования.",
            },
            {
                type: "heading",
                text: "2006",
            },
            {
                type: "paragraph",
                text: "Впервые в России внедрена систему для инвестора\n совершать сделки на международных рынках через\nлицензированную российскую компанию.",
            },
        ],
    },
    {
        id: "2",
        year: "2008-2018",
        image: i2008,
        items: [
            {
                type: "heading",
                text: "2008",
            },
            {
                type: "paragraph",
                text: "Запущен информационно-аналитический портал БКС\nЭкспресс.",
            },
            {
                type: "heading",
                text: "2013",
            },
            {
                type: "paragraph",
                text: "БКС – абсолютный лидер брокерского рынка России\nпо версии РБК.",
            },
            {
                type: "heading",
                text: "2014",
            },
            {
                type: "paragraph",
                text: "Первыми дали возможность клиентам покупать\nмеждународные ценные бумаги в рамках «Единого\nброкерского счета». Единственный брокер,\nпредоставляющий клиентам самое большое\nколичество площадок для торговли.",
            },
            {
                type: "heading",
                text: "2015",
            },
            {
                type: "listItem",
                text: "Запущено мобильное приложение «Мой брокер» -\nодно из первых инвестиционных приложений на\nроссийском рынке.",
            },
            {
                type: "listItem",
                text: "Запущено первое на рынке онлайн-открытие\nброкерского счета.",
            },
            {
                type: "heading",
                text: "2018",
            },
            {
                type: "paragraph",
                text: "Стартовала система управления капиталом\n«Искусственный интеллект».",
            },
        ],
    },
    {
        id: "3",
        year: "2019-2020",
        image: i2019,
        items: [
            {
                type: "heading",
                text: "2019",
            },
            {
                type: "listItem",
                text: "БКС первым среди брокеров предложил услугу\nпополнения брокерского счёта через Систему\nбыстрых платежей.",
            },
            {
                type: "listItem",
                text: "Выпуск первых структурных облигаций,\nзарегистрированных по российскому праву.",
            },
            {
                type: "listItem",
                text: "Первый валютный фонд на российском рынке,\nсозданный с нуля.",
            },
            {
                type: "listItem",
                text: "БКС запустил площадку с инвестиционными\nстратегиями Fintarget. Создан исследовательский\nфинтех-центр в партнёрстве со Сколково.",
            },
            {
                type: "listItem",
                text: "БКС активно внедряет в свой бизнес решения,\nразработанные резидентами Технопарка.",
            },
            {
                type: "heading",
                text: "2020",
            },
            {
                type: "listItem",
                text: "Масштабный ребрендинг финансовой группы БКС,\nобъединение бизнес-подразделений под единым\nмастер-брендом — «БКС Мир инвестиций».",
            },
            {
                type: "listItem",
                text: "БКС запустил первые на рынке именные\nСберсертификаты, снова подтвердив свой статус\nлидера в отрасли.",
            },
        ],
    },
    {
        id: "4",
        year: "2021",
        image: i2021,
        items: [
            {
                type: "listItem",
                text: "БКС запустил первый биржевый паевой\nинвестиционный фонд (БПИФ) рублевых\nкорпоративных облигаций.",
            },
            {
                type: "listItem",
                text: "Запустили новое направление для\nквалифицированных инвесторов — сделки pre-IPO,\nкоторые позволяют клиентам инвестировать в\nперспективные компании до выхода на публичное\nразмещение.",
            },
            {
                type: "listItem",
                text: "Приложение БКС Мир инвестиций заняло\nлидерские позиции в рейтинге цифровых\nсервисов Markswebb.",
            },
            {
                type: "listItem",
                text: "БКС получил лицензию на осуществление\nдеятельности форекс-дилера. БКС-Форекс\nпредоставляет клиентам доступ на рынок форекс\nи дает возможность заработать на разнице курсов\nосновных мировых валют.",
            },
        ],
    },
    {
        id: "5",
        year: "2022",
        image: i2022,
        items: [
            {
                type: "listItem",
                text: "БКС первым среди крупных российских брокеров\nвышел на азиатский рынок, открыв клиентам\nдоступ к торгам ценными бумагами гонконгских и\nкитайских компаний с первичным листингом на\nГонконгской бирже.",
            },
            {
                type: "listItem",
                text: "БКС стал лауреатом премии «Финансовая элита\nРоссии» в номинациях «Гран-при: Брокерская\nкомпания года» и «Надёжность».",
            },
            {
                type: "listItem",
                text: "Investfunds Awards присудила БКС премию в\nноминациях «Лучшая брокерская компания для\nрозничных инвесторов» и «Advisory – лучшая\nуслуга по управлению активами для\nсостоятельных клиентов», а Investment Leaders\nAward — в номинациях «Лучшая инвестиционная\nкомпания для квалифицированных инвесторов»,\n«Лучшая аналитика для инвесторов»,\n«Партнёрская программа года».",
            },
        ],
    },
    {
        id: "6",
        year: "2023",
        image: i2023,
        items: [
            {
                type: "paragraph",
                text: "БКС запускает первый в России ПИФ с регулярными\nвыплатами на брокерский счет, доступный к покупке\nна Мосбирже.",
            },
            {
                type: "heading",
                text: "В этом году наш долголетний опыт был отмечен\nноминациями премии Frank Invest & Insurance Award:",
            },
            {
                type: "listItem",
                text: "Лучший брокер для розничного инвестора",
            },
            {
                type: "listItem",
                text: "Лучшая УК для розничного инвестора",
            },
        ],
    },
    {
        id: "7",
        year: "2024",
        image: i2024,
        items: [
            {
                type: "listItem",
                text: "БКС стал первым брокером, который подключился\nк системе быстрых переводов ценных бумаг.",
            },
            {
                type: "listItem",
                text: "БКС запустил первого на российском рынке\nголосового инвестиционного помощника «Финс»,\nприменяющего большие языковые модели (LLM).",
            },
            {
                type: "listItem",
                text: "По версии Frank Private Banking Award 2024 БКС\nУльтима стала победителем в номинации «Лучшие\nвозможности для инвестирования капитала».",
            },
            {
                type: "listItem",
                text: "А в рамках премии Frank Invest&Insurance Award\n2024 «БКС Мир инвестиций» признали «Лучшим\nброкером для розничного инвестора».",
            },
            {
                type: "listItem",
                text: "Согласно Digital Investment Rank 2024 мобильное\nприложение БКС Мир инвестиций занимает\nлидерские позиции в рейтинге Markswebb среди\nвсех брокерских приложений.",
            },
        ],
    },
    {
        id: "8",
        year: "2025",
        image: i2025,
        items: [
            {
                type: "paragraph",
                text: "БКС включен Банком России в реестр операторов\nинформационных систем ЦФА.",
            },
        ],
    },
];
